module.exports = __webpack_public_path__ + "img/Logo.e5e5b1b6.png";